import { DateTime } from 'luxon';

import formatDate from './date';

export default function (value, locale, timezone = 'local') {
    return formatDate(value, DateTime.TIME_SIMPLE, locale, timezone);
}
